import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { PaginatedResponse } from "../../../core/http/paginated-response.type";
import { QueryParams } from "../../../core/http/query-params.type";
import { DEFAULT_QUERY_PARAMS } from "../../../shared/constants/services";
import { CompanyAttachment } from "./company-attachment.type";

@Injectable({
  providedIn: "root",
})
export class CompanyAttachmentService {
  basePath = `${environment.serverUrl}/companies`;

  constructor(private http: HttpClient) {}

  getCompanyAttachments(
    companyId: string,
    options?: QueryParams<CompanyAttachment>,
  ): Observable<PaginatedResponse<CompanyAttachment>> {
    let params: HttpParams = new HttpParams();
    options = { ...DEFAULT_QUERY_PARAMS, ...options };
    for (const key in options) {
      if (options[key]) {
        params = params.set(key, JSON.stringify(options[key]));
      }
    }
    return this.http.get<CompanyAttachment>(`${this.basePath}/${companyId}/company-attachments`, { params }).pipe(
      tap((_data: any) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return throwError(error);
    };
  }
}
